// ***** Dependencies *****
import { Button } from "@fc/devteam-components-library";
import { useTranslation } from "react-i18next";

// ***** Interfaces, Types and imports *****
import ErrorImage from "../../../public/emptystates/errorwindow.svg";

/**
 * Default fallback for `ErrorBoundary`. Kept as a separate function component
 * because the boundary itself is a class and cannot call hooks.
 */
const ErrorFallback = (): JSX.Element => {
    const { t } = useTranslation(["common"]);

    return (
        <div className="Construction">
            <img
                className="Construction__Icon"
                src={ErrorImage}
                alt={t("errorBoundary.title")}
            />
            <p className="Construction__Text">{t("errorBoundary.title")}</p>
            <p className="Construction__TextSmall">{t("errorBoundary.text")}</p>
            <div className="ButtonComponent">
                <Button
                    buttontext={t("errorBoundary.retry")}
                    buttontype="button"
                    action={() => window.location.reload()}
                />
            </div>
        </div>
    );
};

export default ErrorFallback;
